import { TIMEZONES } from '../../../../../helpers/constants'
import { getAssetLink } from '../../../../../helpers/get-asset-link'
import API from '../../../../../api/api'

export const fetchClients = async (builingId = 0, trainerId = 0, query = '') => {
  return API.getClients(0, 100, builingId, trainerId, query)
}

export const fetchInitialData = async () => {
  const requests = [
    API.getTrainingTypes(),
    API.getTrainersWithoutUserData(),
    API.getAllBuildings(),
    fetchClients(),
  ]
  const [trainingTypes, trainers, buildings, clients] = await Promise.all(requests)
  return { trainingTypes, trainers, buildings, clients }
}

export const getEventTypeOptions = (trainingTypes = []) =>
  trainingTypes
    .filter((type) => !type.personal)
    .map((classType) => ({
      id: classType.id,
      avatar: classType.icon,
      text: classType.name,
      color: classType.color,
      personal: classType.personal,
      bookingType: classType.bookingType ? classType.bookingType.name : '',
      value: classType.id,
      label: classType.name,
    }))

export const getAppointmentEventTypeOptions = (trainingTypes) =>
  trainingTypes
    .filter((type) => type.personal)
    .map((classType) => ({
      id: classType.id,
      avatar: classType.icon,
      text: classType.name,
      color: classType.color,
      personal: classType.personal,
      bookingType: classType.bookingType ? classType.bookingType.name : '',
    }))

export const getClientOptions = (clients) =>
  clients.map((client) => ({
    id: client.id,
    timezone: client.buildingId ? client.buildingId.timezone : TIMEZONES.CT,
    avatar: getAssetLink({ file: client.user.avatar, path: 'chitown-avatar/avatar' }) || 'clothes',
    text: client.user.firstName + ' ' + client.user.lastName,
    value: client.id,
    label: client.user.firstName + ' ' + client.user.lastName,
  }))

export const getTrainerOptions = (trainers) =>
  trainers.map((trainer) => ({
    id: trainer.id,
    avatar: getAssetLink({ path: 'chitown-avatar/avatar', file: trainer.user.avatar }) || 'clothes',
    text: trainer.user.firstName + ' ' + trainer.user.lastName,
    value: trainer.id,
    label: trainer.user.firstName + ' ' + trainer.user.lastName,
  }))

export const getBuildingOptions = (buildings) =>
  buildings.map((building) => ({
    ...building,
    value: building.id,
    label: building.name,
  }))
